import * as React from 'react'
// CHelper
import {cn} from '@frontrow/console/src/lib/utils'
// CComponents
import {Label} from '@frontrow/console/src/components/ui/label'

type Props = {
  children: React.ReactNode
  label: string
  wrapperStyle?: string
  required?: boolean
  htmlFor?: string
}

export default function FormField(props: Props): React.ReactElement {
  const {label, wrapperStyle, required, htmlFor, children} = props

  const requiredTag = required === true ? '*' : ''

  return (
    <div className={cn('mb-3 pr-3', wrapperStyle)}>
      <Label htmlFor={htmlFor}>{`${label}${requiredTag}`}</Label>
      <div className="w-full [&_input]:w-full">{children}</div>
    </div>
  )
}
